import { render, staticRenderFns } from "./CreditRating.vue?vue&type=template&id=1282a9a4&scoped=true&"
import script from "./CreditRating.vue?vue&type=script&lang=js&"
export * from "./CreditRating.vue?vue&type=script&lang=js&"
import style0 from "./CreditRating.vue?vue&type=style&index=0&id=1282a9a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1282a9a4",
  null
  
)

export default component.exports